var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1250,
    height: 918,
    viewBox: "0 0 1250 918",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M591.262 -277.78L621.454 193.732L90.5762 29.8372L447.849 410.577L0 773.667L646.614 551.779L801.036 917.39L860.475 551.779L1363.68 636.17L983.759 410.577L1464.32 163.55L961.115 221.468L1119.62 -141.622L830.282 133.217L591.262 -277.78Z",
    fill: "url(#paint0_linear_1110_10236)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1110_10236",
    x1: 1435,
    y1: 177.237,
    x2: 411.714,
    y2: 752.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#115EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#115EF3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDesktop);
export default __webpack_public_path__ + "static/media/star-desktop.1a3bf77521f6c855d55ba0ee6a950ed0.svg";
export { ForwardRef as ReactComponent };